<template>
  <div class="gamescore">
    <base-score-header
      ref="headerRef"
      :head_id="head_id"
      :name="name"
      :my_name="my_name"
      :account_list="account_list"
      :lv="lv"
      :is_self="is_self"
      @click="changeGame"
    ></base-score-header>
    <base-radio
      ref="typeRef"
      :list="arr"
      :val="tab"
      @choose="changeTab"
      :is_larger="`true`"
    ></base-radio>
    <div class="left-box" v-if="tab == 1">
      <div class="part part1">
        <div class="dota-info">
          <div class="img">
            <img
              :src="
                `https://www.09game.com/statics/${
                  gametypeid == dotaGameId ? 'segment/36' : 'IMsegment/1'
                }/${seasonScore.level > 16 ? 17 : seasonScore.level}.png`
              "
            />
          </div>
          <p class="name">{{ seasonScore.name }}</p>

          <p
            class="score"
            v-if="isNotEmptyObject(season) && season.score >= 1700"
          >
            <!-- <span>竞技积分：</span> -->
            <!-- {{ season.arena_score }}分 -->
            <span>已达最高段位</span>
          </p>
          <div class="star" v-else>
            <div v-if="seasonScore.star > 0">
              <img
                v-for="(item, index) in seasonScore.star"
                :key="index"
                :src="
                  `https://www.09game.com/statics/${
                    gametypeid == dotaGameId ? 'segment/36' : 'IMsegment/1'
                  }/${seasonScore.level > 16 ? 17 : seasonScore.level}-1.png`
                "
              />
            </div>
            <div v-if="seasonScore.half">
              <img
                :src="
                  `https://www.09game.com/statics/${
                    gametypeid == dotaGameId ? 'segment/36' : 'IMsegment/1'
                  }/halfstar.png`
                "
              />
            </div>
            <div v-if="seasonScore.empty > 0">
              <img
                v-for="(item, index) in seasonScore.empty"
                :key="index"
                :src="
                  `https://www.09game.com/statics/${
                    gametypeid == dotaGameId ? 'segment/36' : 'IMsegment/1'
                  }/${seasonScore.level > 16 ? 17 : seasonScore.level}-0.png`
                "
              />
            </div>
          </div>
        </div>
        <!-- <div v-else class="ds-info">
            <p class="name">天梯积分</p>
            <p class="score">{{ season.score || 1000 }}</p>
          </div> -->
      </div>

      <div class="part part2">
        <ul class="data-ul">
          <li class="data-li">
            <div class="line title">
              <p>
                <span>模式</span>
              </p>
              <p>
                <span>赛季模式</span>
              </p>
              <p>
                <span>历史战绩</span>
              </p>
            </div>
          </li>
          <li class="data-li">
            <div class="line">
              <p>总场次</p>
              <p>
                {{
                  !isNotEmptyObject(season) || season.total_times == 0
                    ? "-"
                    : season.total_times + "场"
                }}
              </p>
              <p>
                {{
                  !isNotEmptyObject(total) || total.total_times == 0
                    ? "-"
                    : total.total_times + "场"
                }}
              </p>
              <div class="divider"></div>
            </div>
          </li>
          <li class="data-li">
            <div class="line">
              <p>胜率</p>
              <p>
                {{
                  !isNotEmptyObject(season) || season.total_times == 0
                    ? "-"
                    : Math.round(
                        (season.total_win / season.total_times) * 100
                      ) + "%"
                }}
              </p>
              <p>
                {{
                  !isNotEmptyObject(total) || total.total_times == 0
                    ? "-"
                    : Math.round((total.total_win / total.total_times) * 100) +
                      "%"
                }}
              </p>
              <div class="divider"></div>
            </div>
          </li>
          <li class="data-li">
            <div class="line">
              <p>胜场</p>
              <p>
                {{
                  !isNotEmptyObject(season) || season.total_times == 0
                    ? "-"
                    : season.total_win + "场"
                }}
              </p>
              <p>
                {{
                  !isNotEmptyObject(total) || total.total_win == 0
                    ? "-"
                    : total.total_win + "场"
                }}
              </p>
              <div class="divider"></div>
            </div>
          </li>
          <li class="data-li">
            <div class="line">
              <p>排名</p>
              <p>{{ !isNotEmptyObject(season) ? "-" : season.seasonRank }}</p>
              <p>-</p>
              <div class="divider"></div>
            </div>
          </li>
        </ul>
      </div>

      <div class="part part3">
        <div class="title" v-for="(item, index) in 6" :key="index">
          <img
            :src="
              `https://www.09game.com/statics/userscore2/img/title/${
                index == 0
                  ? 2
                  : index == 1
                  ? 1
                  : index == 2
                  ? 4
                  : index == 3
                  ? 16
                  : index == 4
                  ? 8
                  : 32
              }.png`
            "
            alt
            srcset
          />
          <div class="num" v-if="isNotEmptyObject(totalTitle)">
            {{
              index == 0
                ? totalTitle.total_win_money
                : index == 1
                ? totalTitle.total_win_kill
                : index == 2
                ? totalTitle.total_win_assit
                : index == 3
                ? totalTitle.total_failed_best
                : index == 4
                ? totalTitle.total_win_bad
                : totalTitle.total_failed_bad
            }}
          </div>
          <div class="num" v-else>0</div>
        </div>
      </div>
      <!-- 雷达图 -->
      <div class="part part4">
        <div ref="radarRef" class="radar-box"></div>
      </div>
    </div>

    <!-- 最近10条游戏记录 -->
    <div class="right-box" v-else>
      <div class="record-box" v-if="recent_list.length > 0">
        <div class="log-wrapper" style="overflow-x: hidden">
          <ul class="list">
            <li
              v-for="(item, index) in recent_list"
              class="list-item"
              :key="index"
              @click="openIframe(item)"
            >
              <div class="img">
                <img
                  :src="
                    `http://cdn.09game.com/resources/game_avator/${item.hero}.jpg`
                  "
                  alt
                />
              </div>
              <div class="info">
                <p class="hero">
                  {{ item.hero_name ? item.hero_name : "--" }}
                  <span>Lv.{{ item.hero_level }}</span>
                </p>
                <p class="mode">
                  {{
                    item.g_source == 3
                      ? "赛季模式"
                      : item.g_source == 0
                      ? "自由模式"
                      : item.g_source == 4 && gametypeid == 153
                      ? "天梯匹配"
                      : "自由匹配"
                  }}
                </p>
                <p class="kda">
                  {{
                    `KDA: ${item.kill_count}/${item.killed_count}/${item.assist_count}`
                  }}
                </p>
              </div>
              <div class="info info2">
                <p :class="`result ${item.game_result == 0 ? 'win' : 'lose'}`">
                  {{
                    item.game_result == 0
                      ? "胜利"
                      : item.game_result == 1
                      ? "失败"
                      : item.game_result == 2 || item.game_result == 3
                      ? "逃跑"
                      : "未知"
                  }}
                </p>
                <p class="time">{{ item.stime }}</p>
              </div>
              <div class="divider"></div>
            </li>
          </ul>
        </div>
        <div class="toast">
          仅展示最近10条
          <br />更多记录请前往09电竞PC端官网查看
        </div>
      </div>

      <div class="no-data" v-else-if="recent_list.length == 0">
        <img
          src="https://www.09game.com/statics/userscore2/img/norecorddata.png"
          alt
          srcset
        />
      </div>
    </div>

    <div class="iframe-box" v-if="iframeUrl">
      <div class="close" @click="closeIframe"></div>
      <iframe
        :src="iframeUrl"
        class="iframe-container"
        id="iframeContainer"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>
<script>
import { baseUrls } from "@/utils/baseUrlConfig";
const base_url = baseUrls.user_url;
import dotaSeason from "@/utils/seasondan";

export default {
  name: "gamescore",
  data() {
    return {
      is_self: true,
      recent_list: [],
      user_info: {},
      my_name: this.$storage.getUserName(),
      user_id: "",
      head_id: 0,
      lv: 0,
      name: "",
      token: this.$storage.getToken(),
      account_list: JSON.parse(this.$storage.getAccountList()),
      tab: 1,
      arr: [
        { value: 1, name: "DOTA战绩" },
        { value: 2, name: "最近游戏" }
      ],
      seasonScore: {}, //赛季详细信息
      totalData: {},
      freeData: {},
      seasonData: {},
      ownTotalData: {},
      ownFreeData: {},
      ownSeasonData: {},
      totalTitle: {
        total_win_money: 0,
        total_win_kill: 0,
        total_win_assit: 0,
        total_failed_best: 0,
        total_win_bad: 0,
        total_failed_bad: 0
      },
      ownTotalTitle: {
        total_win_money: 0,
        total_win_kill: 0,
        total_win_assit: 0,
        total_failed_best: 0,
        total_win_bad: 0,
        total_failed_bad: 0
      },
      season: {},
      free: {},
      total: {},
      gametypeid: 1,
      dsGameId: 153,
      dotaGameId: 1,
      iframeUrl: "",
      isFirstEnter: false // 是否第一次进入，默认false
    };
  },
  watch: {
    gametypeid(newValue, oldValue) {
      // console.log(`gametypeid 发生变化：${oldValue} → ${newValue}`);
      this.arr[0].name =
        newValue == 1
          ? "DOTA战绩"
          : newValue == 2
          ? "IM战绩"
          : newValue == 21
          ? "OMG战绩"
          : newValue == 153
          ? "Dota DS战绩"
          : "";
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "GameScoreSearch") {
      to.meta.isBack = true;
      // console.log('从搜索页来的。、。。。。');
    }
    next(vm => {
      if (from.path != "/gamescore/search" && vm.$common.checkToken(vm.token)) {
        vm.$http.set_anchor(3, vm.token);
        // console.log('写入锚点====战绩中心');
      }
    });
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      this.init();
    }
    this.$route.meta.isBack = false;
    this.isFirstEnter = false;
  },
  created() {
    // console.log('当前赛季=====',this.current_season);
    this.isFirstEnter = true;
    this.requireToken();
  },
  methods: {
    requireToken() {
      var Ucookie = this.token;
      if (Ucookie != null) {
        var now = new Date().getTime();
        if (now >= Ucookie.split("-")[3] * 1000) {
          //token过期
          this.get_auth();
        } else {
          this.init();
        }
      } else {
        this.get_auth();
      }
    },
    get_auth() {
      window.location.replace(base_url + "/GetWxOpenid?fromPage=gamescore");
    },
    // 初始化
    async init() {
      if (this.$route.query.type) {
        this.gametypeid = parseInt(this.$route.query.type);
        this.$nextTick(() => {
          this.$refs.headerRef.gametypeid = this.gametypeid;
        });
      }
      this.token = this.$storage.getToken();
      if (this.$route.query.userid) {
        // 搜索他人战绩
        await this.$http.getUserPub(this.$route.query.userid).then(res => {
          if (res.result == 0 && res.temp && res.temp.length > 0) {
            this.user_id = this.$route.query.userid;
            this.is_self =
              this.user_id == this.token.split("-")[0] ? true : false;
            this.name = res.temp[0].user_name;
            this.head_id = res.temp[0].avatar_head;
            this.lv = res.temp[0].level;
          }
        });
      } else {
        // 我的战绩
        await this.$http.getUserInfo(this.token).then(res => {
          if (res.result == 0 && res.temp) {
            this.user_info = Object.assign({}, this.user_info, res.temp);
            this.$storage.setUserId(this.user_info.user_id);
            this.$storage.setUserName(this.user_info.name);
            this.$storage.setHeadId(this.user_info.avtar_head);
            this.$storage.setUserLevel(this.user_info.level);
            this.$storage.setUserFlag(this.user_info.flag);
            this.user_id = this.user_info.user_id;
            this.my_name = this.user_info.name;
            this.head_id = this.user_info.avtar_head;
            this.name = this.user_info.name;
            this.lv = this.user_info.level;
            this.is_self =
              this.user_id == this.token.split("-")[0] ? true : false;
          }
        });
        this.$http.getAllUser(this.token).then(res => {
          if (res.result == 0 && res.msg && res.msg.length > 0) {
            this.account_list = res.msg;
            this.$storage.setAccountList(JSON.stringify(res.msg));
          } else {
            this.account_list = [];
          }
        });
      }
      await this.initData();
    },
    // 获取我的战绩数据
    initData() {
      this.getGameTitle();
      this.getSeasonSummary();
    },
    // 打开iframe内嵌页
    openIframe(item) {
      //this.iframeUrl = `http://127.0.0.1:8001/3-%E5%AE%98%E7%BD%91%E9%A1%B5%E9%9D%A2/2-2020gamescore-%E6%88%98%E7%BB%A9%E4%B8%AD%E5%BF%83/web/gamedetail/153.html?sessid=0&gameid=${item.g_id}`
      this.iframeUrl = `https://www.09game.com/html/2020gamescore/web/gamedetail/${this.gametypeid}.html?sessid=0&gameid=${item.g_id}`;
    },

    closeIframe() {
      this.iframeUrl = "";
    },
    changeTab(val) {
      if (val == this.tab) return;
      this.tab = val;
      // console.log(this.tab)
      if (val == 2) {
        this.queryBasicDataList();
      } else if (val == 1) {
        this.initData();
      }
    },
    queryBasicDataList() {
      this.$http
        .queryBasicDataList(this.user_id, this.gametypeid, 0, 10, this.token)
        .then(response => {
          if (response.code == 0) {
            let arr = response.data.listEntity;
            arr = arr.map(res => {
              res.hero = this.$common.convertWar3Id(res.hero_id);
              return res;
            });
            this.recent_list = arr;
          } else {
            this.recent_list = [];
          }
          // console.log(this.recent_list);
        });
    },
    // 切换游戏类型
    changeGame(val) {
      this.gametypeid = val;
      this.tab = 1;
      this.$refs.typeRef.value = this.tab;
      this.initData();
    },
    // 查询当前战绩数据
    getSeasonSummary() {
      this.season = {};
      this.free = {};
      this.total = {};
      this.$http
        .querySeasonSummary(this.user_id, this.gametypeid, this.token)
        .then(response => {
          if (response.code == 0) {
            if (response.data.season.length > 0) {
              this.season = Object.assign(
                {},
                this.season,
                response.data.season[0]
              );
            }
            if (response.data.free.length > 0) {
              this.free = Object.assign({}, this.free, response.data.free[0]);
            }
            if (response.data.total.length > 0) {
              this.total = Object.assign(
                {},
                this.total,
                response.data.total[0]
              );
            }
            if (
              this.gametypeid == this.dotaGameId &&
              this.isNotEmptyObject(this.season)
            ) {
              this.season.score = this.season.single_score;
            }
            if (this.isNotEmptyObject(this.season)) {
              if (this.season.score >= 700) {
                this.getUserRanking();
              } else {
                this.season.seasonRank = "待定";
              }
            }
            this.seasonScore = dotaSeason[1](
              this.isNotEmptyObject(this.season) ? this.season.score : 100
            );
            this.seasonScore.star =
              this.seasonScore.star > 4
                ? this.seasonScore.half
                  ? 3
                  : 4
                : this.seasonScore.star;
            this.seasonScore.empty =
              this.seasonScore.empty < 0 ? 0 : this.seasonScore.empty;
            this.$forceUpdate();
            // console.log(this.season)
          }
        });
    },
    // 查询用户赛季排名
    getUserRanking() {
      let text = "";
      this.$http.queryUserRanking(this.user_id, this.gametypeid, this.token).then(res => {
        if (res.data.length > 0) {
          if (this.gametypeid == this.dotaGameId) {
            // data
            if (
              res.data[0].rank_number1 <= 999 &&
              res.data[0].rank_number1 != 0
            ) {
              text = `第${res.data[0].rank_number1}名`;
            } else {
              text = `${100 - res.data[0].rank_scale}%`;
            }
          } else {
            if (
              res.data[0].rank_number <= 999 &&
              res.data[0].rank_number != 0
            ) {
              text = `第${res.data[0].rank_number}名`;
            } else {
              text = `${100 - res.data[0].rank_scale}%`;
            }
          }
        } else {
          text = "待定";
        }
        // this.season = Object.assign(this.season, {seasonRank: text})
        this.$set(this.season, "seasonRank", text);
      });
    },
    // 查询称号
    getGameTitle() {
      this.totalTitle = {};
      this.ownTotalTitle = {};
      this.$http
        .queryGameTitle(this.user_id, this.gametypeid, this.token)
        .then(response => {
          if (response.code == 0) {
            this.totalTitle = Object.assign(
              this.totalTitle,
              response.data.total[0]
            );
          }

          if (!this.is_self) {
            this.$http
              .queryGameTitle(this.token.split("-")[0], this.gametypeid, this.token)
              .then(response => {
                if (response.code == 0) {
                  this.ownTotalTitle = Object.assign(
                    this.ownTotalTitle,
                    response.data.total[0]
                  );
                }
                this.getGameData();
              });
          } else {
            this.getGameData();
          }
        });
    },
    // 查询雷达图数据
    getGameData() {
      this.totalData = {};
      this.freeData = {};
      this.seasonData = {};
      this.ownTotalData = {};
      this.ownFreeData = {};
      this.ownSeasonData = {};
      this.$http.queryRadarData(this.user_id, this.gametypeid, this.token).then(res => {
        if (res.code == 0) {
          this.totalData = Object.assign(this.totalData, res.data.total[0]);
          this.freeData = Object.assign(this.freeData, res.data.free[0]);
          this.seasonData = Object.assign(this.seasonData, res.data.season[0]);
        }

        if (!this.is_self) {
          this.$http
            .queryRadarData(this.token.split("-")[0], this.gametypeid, this.token)
            .then(res => {
              if (res.code == 0) {
                this.ownTotalData = Object.assign(
                  this.ownTotalData,
                  res.data.total[0]
                );
                this.ownFreeData = Object.assign(
                  this.ownFreeData,
                  res.data.free[0]
                );
                this.ownSeasonData = Object.assign(
                  this.ownSeasonData,
                  res.data.season[0]
                );
              }
              this.drawRadar_def(this.totalData, this.ownTotalData);
            });
        } else {
          this.drawRadar_def(this.totalData);
        }
      });
    },
    // 绘制雷达图
    drawRadar_def(totalData, ownTotalData) {
      let radarData = {
        value: [],
        name: this.is_self ? "我的" : this.name,
        symbolSize: 5
      };
      let ownRadarData = {
        value: ownTotalData ? [] : null,
        name: "我的",
        symbolSize: 5
      };

      // 根据gametypeid确定游戏模式的max值配置
      let maxConfig = {
        mvp: 0.8,
        kda: 4,
        gold: 1.7,
        tower: 2.4,
        support: 3.0
      };

      if (this.gametypeid == 1) {
        // dota
        maxConfig = { mvp: 0.8, kda: 4, gold: 1.7, tower: 2.4, support: 3.0 };
      } else if (this.gametypeid == 2) {
        // im
        maxConfig = { mvp: 1.4, kda: 3, gold: 2.6, tower: 4.0, support: 2.5 };
      } else if (this.gametypeid == 21) {
        // omg
        maxConfig = { mvp: 1.0, kda: 3.5, gold: 2.0, tower: 2.4, support: 2.2 };
      } else if (this.gametypeid == 153) {
        // ds
        maxConfig = { mvp: 1.0, kda: 3, gold: 2.2, tower: 2.4, support: 2.0 };
      }

      // 计算雷达图数据的辅助函数（与JS文件逻辑一致）
      const calculateRadarValues = (data, titleData) => {
        const totalTimes = data.total_times || 0;
        const totalKilled = data.total_killed || 0;
        const values = [];

        // 1. 闪亮指数（MVP）= (1.1*mvp+0.5*杀+0.4*助+1*灵+0.1*三杀)/总场
        if (totalTimes == 0) {
          values.push(0);
        } else {
          const mvp = titleData.total_win_money || 0;
          const kill = titleData.total_win_kill || 0;
          const assist = titleData.total_win_assit || 0;
          const ling = titleData.total_failed_best || 0;
          const tripleKill = data.total_triple_kill || 0;
          let tempShining =
            Math.round(
              ((1.1 * mvp +
                0.5 * kill +
                0.4 * assist +
                1 * ling +
                0.1 * tripleKill) /
                totalTimes) *
                10
            ) / 10;
          values.push(
            tempShining > maxConfig.mvp ? maxConfig.mvp : tempShining
          );
        }

        // 2. 战斗(KDA) = (总击杀+总助攻)/总死亡
        if (totalKilled == 0) {
          values.push(0);
        } else {
          const kill = data.total_kill || 0;
          const assist = data.total_assisant || 0;
          let tempKda = Math.round(((kill + assist) / totalKilled) * 10) / 10;
          if (tempKda < 1) {
            tempKda = 1;
          } else if (tempKda > maxConfig.kda) {
            tempKda = maxConfig.kda;
          }
          values.push(tempKda);
        }

        // 3. 打钱能力 = 总金钱/(总场次*10000)
        if (totalTimes == 0) {
          values.push(0);
        } else {
          const totalMoney = data.total_money || 0;
          let tempGold =
            Math.round((totalMoney / (totalTimes * 10000)) * 10) / 10;
          // 根据游戏类型设置最小值
          let minGold = 0.5;
          if (this.gametypeid == 2) minGold = 1.3;
          else if (this.gametypeid == 21) minGold = 0.9;
          else if (this.gametypeid == 153) minGold = 1.2;
          if (tempGold < minGold) {
            tempGold = minGold;
          } else if (tempGold > maxConfig.gold) {
            tempGold = maxConfig.gold;
          }
          values.push(tempGold);
        }

        // 4. 推塔能力 = (总推塔+2*总推兵营)/总场次
        if (totalTimes == 0) {
          values.push(0);
        } else {
          const pushTower = data.total_push_tower_count || 0;
          const pushRax = data.total_push_rax_count || 0;
          let tempTower =
            Math.round(((pushTower + 2 * pushRax) / totalTimes) * 10) / 10;
          // 根据游戏类型设置最小值：IM模式0.4，其他模式0.2
          let minTower = this.gametypeid == 2 ? 0.4 : 0.2;
          if (tempTower < minTower) {
            tempTower = minTower;
          } else if (tempTower > maxConfig.tower) {
            tempTower = maxConfig.tower;
          }
          values.push(tempTower);
        }

        // 5. 辅助能力 = (0.05*眼+1*雾+0.5*粉+10*宝石-0.01*死亡-0.2*躺-0.3僵)/总场
        if (totalTimes == 0) {
          values.push(0);
        } else {
          const eye = data.total_eye || 0;
          const smoke = data.total_smoke || 0;
          const dust = data.total_dust || 0;
          const gem = data.total_gem || 0;
          const killed = totalKilled || 0;
          const tang = titleData.total_win_bad || 0;
          const jiang = titleData.total_failed_bad || 0;
          let tempSupport =
            Math.round(
              ((0.05 * eye +
                1 * smoke +
                0.5 * dust +
                10 * gem -
                0.01 * killed -
                0.2 * tang -
                0.3 * jiang) /
                totalTimes) *
                10
            ) / 10;
          if (tempSupport > maxConfig.support) {
            tempSupport = maxConfig.support;
          } else if (tempSupport < 0) {
            tempSupport = 0;
          }
          values.push(tempSupport);
        }

        return values;
      };

      // 计算雷达图数据（顺序：MVP、KDA、打钱、推塔、辅助）
      radarData.value = calculateRadarValues(totalData, this.totalTitle);

      if (ownTotalData) {
        ownRadarData.value = calculateRadarValues(
          ownTotalData,
          this.ownTotalTitle
        );
      }

      // 调用drawRadar绘制雷达图（使用原始值，max使用实际配置值）
      this.drawRadar(
        [
          { text: "MVP指数", max: maxConfig.mvp },
          { text: "（战力）KDA", max: maxConfig.kda },
          { text: "打钱能力", max: maxConfig.gold },
          { text: "推塔能力", max: maxConfig.tower },
          { text: "辅助能力", max: maxConfig.support }
        ],
        radarData,
        ownRadarData
      );
    },
    isNotEmptyObject(obj) {
      return Object.keys(obj).length !== 0;
    },
    //绘制雷达图
    drawRadar(indicator, radarData, ownRadarData) {
      var myChart = this.$echarts.init(this.$refs.radarRef);

      // 将数据值映射到雷达图显示范围（与controller.js逻辑一致）
      // 网格线在30%、60%、90%（最外层90%）
      // 规则：
      // 1. 如果所有维度都是0，所有维度显示0%（没玩过）
      // 2. 如果至少有一个维度不是0，所有维度都最低显示30%
      // 3. 计算百分比(rawValue/max*100)，低于30%显示30%，大于100%显示100%，中间正常显示
      const normalizeData = (data, indicators, hasAnyNonZero) => {
        var normalized = {
          value: [],
          name: data.name,
          symbolSize: data.symbolSize
        };

        // 如果所有维度都是0，都显示0%
        if (!hasAnyNonZero) {
          for (var i = 0; i < data.value.length; i++) {
            normalized.value.push(0);
          }
          return normalized;
        }

        // 如果有至少一个维度不是0，所有维度都最低显示30%
        for (var i = 0; i < data.value.length; i++) {
          var max = indicators[i].max;
          var rawValue = data.value[i];

          if (rawValue === 0) {
            // 如果值为0，但因为其他维度有数据，所以最低显示30%
            normalized.value.push(30);
          } else {
            // 计算百分比：rawValue / max * 100
            var percentage = (rawValue / max) * 100;
            // 低于30%显示30%，大于100%显示100%，中间正常显示
            if (percentage < 30) {
              normalized.value.push(30);
            } else if (percentage > 100) {
              normalized.value.push(100);
            } else {
              normalized.value.push(Math.round(percentage * 10) / 10);
            }
          }
        }
        return normalized;
      };

      // 统一检查两个数据集是否有任何非零值
      var hasAnyNonZero = false;
      // 检查 radarData
      if (radarData && radarData.value) {
        for (var i = 0; i < radarData.value.length; i++) {
          if (radarData.value[i] !== 0) {
            hasAnyNonZero = true;
            break;
          }
        }
      }
      // 检查 ownRadarData
      if (ownRadarData && ownRadarData.value) {
        for (var i = 0; i < ownRadarData.value.length; i++) {
          if (ownRadarData.value[i] !== 0) {
            hasAnyNonZero = true;
            break;
          }
        }
      }

      var normalizedRadarData = normalizeData(
        radarData,
        indicator,
        hasAnyNonZero
      );
      var data = [normalizedRadarData];
      if (ownRadarData && ownRadarData.value) {
        var normalizedOwnRadarData = normalizeData(
          ownRadarData,
          indicator,
          hasAnyNonZero
        );
        data.push(normalizedOwnRadarData);
      }

      // 修改indicator，将max设为90（这样最外层网格线在90%）
      // splitNumber:3 会自动创建 0%, 30%, 60%, 90% 的网格线
      var normalizedIndicator = indicator.map(function(item) {
        return {
          text: item.text,
          max: 90
        };
      });

      var option = {
        title: { text: "" },
        color: ["#37b6d1", "#f7bc3d"],
        legend: {
          itemGap: 10,
          bottom: "0",
          itemHeight: 4,
          itemWidth: 30,
          textStyle: { color: "#828282" }
        },
        tooltip: { position: [100, 10] },
        radar: [
          {
            indicator: normalizedIndicator,
            center: ["50%", "50%"],
            radius: "75%",
            nameGap: 8,
            splitNumber: 3,
            name: {
              formatter: "{value}",
              textStyle: { color: "#ddddddff", fontSize: 14 },
              triggerEvent: { componentType: "string", value: "" }
            },
            splitArea: {
              areaStyle: {
                color: [
                  "transparent",
                  "transparent",
                  "transparent",
                  "transparent",
                  "transparent"
                ]
              }
            },
            splitLine: { lineStyle: { color: "#dddddd" } },
            axisLine: { lineStyle: { color: "#dddddd" } },
            axisLabel: {
              show: false // 不显示30%、60%、90%这些标签
            },
            legend: { orient: "vertical", tooltip: { trigger: "axis" } }
          }
        ],
        series: [
          {
            name: "",
            type: "radar",
            data: data,
            lineStyle: {
              width: 3
            }
          }
        ],
        textStyle: { color: "#828282" }
      };
      myChart.setOption(option);
      myChart._model.option.color[0] = "#fff";
      window.onresize = myChart.resize;
    }
  }
};
</script>
<style lang="scss" scoped>
.gamescore {
  width: 100%;
  height: 100%;
  .left-box {
    padding-bottom: 0.25rem;
    .part {
      width: 94%;
      height: auto;
      position: relative;
      border-radius: 0.2rem;
      background: #ffffff;
      margin: 0.2rem 3% 0 3%;
      &.part1 {
        height: 1.8rem;
        .dota-info {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          .img {
            width: 1.1rem;
            height: 1.1rem;
            position: absolute;
            top: 50%;
            left: 25%;
            transform: translateY(-50%);
            img {
              width: 100%;
              height: 100%;
              display: block;
            }
          }
          .star {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-wrap: nowrap;
            margin-left: 45%;
            img {
              width: 0.26rem;
              height: 0.26rem;
              margin-right: 0.05rem;
            }
          }
          p {
            width: 100%;
            color: #4f4f4f;
            font-size: 0.2rem;
            height: 0.28rem;
            line-height: 0.28rem;
            padding-left: 45%;
            &.name {
              color: #bd9549;
              font-size: 0.28rem;
              font-weight: bold;
              padding-top: 0.53rem;
            }
            span {
              color: #919191;
            }
          }
        }
        .ds-info {
          .name {
            width: 100%;
            color: #919191;
            font-size: 0.28rem;
            padding-top: 0.53rem;
            text-align: center;
          }
          .score {
            width: 100%;
            color: #bd9549;
            font-size: 0.28rem;
            // height: 0.28rem;
            font-weight: bold;
            // line-height: 0.28rem;
            text-align: center;
            padding-top: 0.1rem;
          }
        }
      }

      &.part2 {
        .data-ul {
          .data-li {
            width: 100%;
            display: block;
            position: relative;
            .line {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 0.82rem;
              &.title {
                height: 0.64rem;
                line-height: 0.64rem;
              }
              p {
                width: 100%;
                text-align: center;
                color: #4f4f4f;
                font-size: 0.22rem;
                vertical-align: middle;
                span {
                  color: #919191;
                  font-size: 0.22rem;
                }
              }
              .divider {
                width: 188%;
                height: 0.01rem;
                background: #dddddd;
                position: absolute;
                top: 0;
                left: 3%;
                transform: scale(0.5);
                transform-origin: left top;
              }
            }
          }
        }
      }

      &.part3 {
        height: 2.98rem;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;
        .title {
          width: 1.86rem;
          height: 0.98rem;
          background: #ffffff;
          border: 0.01rem solid #dddddd;
          display: flex;
          align-items: center;
          align-content: center;
          justify-content: center;
          flex-wrap: wrap;
          margin: 0.1rem;
          img {
            width: auto;
            height: 0.4rem;
            margin-bottom: 0.15rem;
          }
          .num {
            font-size: 0.22rem;
            color: #505050;
            width: 100%;
            height: 0.2rem;
            line-height: 0.2rem;
            text-align: center;
          }
        }
      }

      &.part4 {
        height: 4.78rem;
        position: relative;
        .radar-box {
          width: 100%;
          height: 4rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .right-box {
    .record-box {
      width: 100%;
      height: calc(100vh - 5.5rem);
      margin: 0 auto;
      position: relative;

      .log-wrapper {
        width: 100%;
        height: calc(100% - 1rem);
        margin: 0 auto;
        position: relative;
        margin-top: 0.2rem;

        p {
          font-size: 0.18rem;
          color: #919191;
          text-align: center;
          width: 100%;
          height: 0.3rem;
          line-height: 0.3rem;
        }
        .list {
          width: 94%;
          // height: calc(100% - 0.2rem);
          margin: 0 3%;
          background: #ffffff;
          border-radius: 0.2rem;

          .list-item {
            width: 100%;
            padding: 0 3%;
            height: 1.6rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            .divider {
              width: 188%;
              height: 0.01rem;
              background: #dddddd;
              position: absolute;
              bottom: 0;
              left: 0.23rem;
              transform: scale(0.5);
              transform-origin: left top;
            }
            .img {
              width: 1rem;
              height: 1rem;
              background: #dddddd;
              img {
                width: 100%;
                height: 100%;
                display: inline-block;
              }
            }
            .info {
              width: 4rem;
              height: 100%;
              box-sizing: border-box;
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;
              align-items: center;
              align-content: space-between;
              padding: 0.3rem 0 0.3rem 0.19rem;
              p {
                text-align: left;
                display: block;
                color: #919191;
                font-size: 0.18rem;
                height: 0.23rem;
                line-height: 0.23rem;
                &.hero {
                  font-weight: bold;
                  font-size: 0.22rem;
                  color: #4f4f4f;
                  span {
                    font-weight: normal;
                    font-size: 0.16rem;
                    color: #919191;
                    padding-left: 0.1rem;
                  }
                }
                &.kda {
                  font-size: 0.2rem;
                  color: #f86767;
                }
                &.result {
                  text-align: right;
                  font-size: 0.28rem;
                  color: #02cc3f;
                  font-weight: bold;
                  &.lose {
                    color: #f34343;
                  }
                }

                &.time {
                  text-align: right;
                  font-weight: normal;
                  font-size: 0.16rem;
                  color: #919191;
                }
              }

              &.info2 {
                width: 2rem;
              }
            }
          }
        }
      }

      .toast {
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 0.22rem;
        color: #919191;
        text-align: center;
        width: 100%;
        height: 0.9rem;
        line-height: 0.28rem;
      }
    }

    .no-data {
      width: 100%;
      margin-top: 2rem;
      img {
        width: 3rem;
        height: auto;
        display: block;
        margin: 0 auto;
      }
      p {
        font-size: 0.22rem;
        color: #919191;
        text-align: center;
        width: 100%;
        height: 0.3rem;
        line-height: 0.3rem;
        span {
          display: block;

          color: #212121;
          font-size: 0.36rem;
          font-weight: bold;
        }
      }
    }
  }

  .iframe-box {
    width: 90%;
    height: 462px;
    //    overflow-x:scroll!important;
    //     -webkit-overflow-scrolling: touch;
    position: absolute;
    top: 3rem;
    left: 5%;
    .close {
      width: 30px;
      height: 30px;
      background: url(~@/assets/img/close.png) 0 0 no-repeat;
      background-size: cover;
      position: absolute;
      z-index: 5;
      top: 0;
      right: 0;

      &:hover {
        cursor: default;
        background-position-y: -30px;
      }
    }
    .iframe-container {
      // width: 734px;
      width: 100%;
      height: 100%;
      overflow: auto !important;
      -webkit-overflow-scrolling: touch;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/gamescore/index.vue